<template>
    <MainPage :pageTitle="title" :bgClass="noDocument?'bg-white':'bg-a-gray-efefef'">
        <EmptyDocument v-if="noDocument && !loading"></EmptyDocument>
        <Document v-if="!noDocument && !loading" :document="document"></Document>
    </MainPage>
</template>
<script>
import MainPage from '@/components/Layout/Page/MainPage.vue'
//component
import EmptyDocument from "../component/EmptyDocument.vue";
import Document from "../component/Document.vue";

//mixin
import AuthPageMixin from "@/mixin/AuthPageMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ModalMixin from '@/mixin/ModalMixin.js';
import ErrorApiMixin from '@/mixin/ErrorApiMixin';

import Account from "@/helper/AccountHelper.js";
//service
import EDocumentApi from "../service/EDocumentApi";
import { useTracking } from "@/feature/TrackingFeature"

export default {
    name: "EDocumentPage",
    mixins: [AuthPageMixin, ModalMixin, LocaleMixin, ErrorApiMixin],
    components: {
        MainPage,
        EmptyDocument,
        Document,
    },
    setup: function() {
        /**@type {import('@/helper/TrackingHelper').TrackingService} */
        const tracking = useTracking()

        return {
            tracking,
        }
    },
    data: function() {
        return {
            title: 'ดาวน์โหลดเอกสารอิเล็กทรอนิกส์',
            bgClass: "bg-white",
            userCookie: {},
            document: {},
            isLoading: true,
        }
    },
    computed: {
        loading: function () {
            return this.isLoading;
        },
        noDocument: function () {
            return !this.document.hasDocument;
        },
    },
    created: function () {
        this.tracking.screenName('edocument_list')
        this.tracking.event("edocument_list_page", "view_edocument_list", "", "");

        this.userCookie = Account.getCacheUser();

        this.init();
    },
    methods: {
        init: async function () {
            this.modal.loadingModal.show();
            await this.apiDocumentLine();
            this.isLoading = false;
            this.modal.loadingModal.hide();
        },
        apiDocumentLine: async function () {
            return new Promise((resolve) => {
                let token = this.userCookie.token;
                EDocumentApi.apiDocumentLine(token).subscribe({
                    next: (document) => {
                        console.log("document",document);
                        this.document = document;
                        resolve(document);
                    },
                    error: (err) => {
                        resolve(null);
                        console.log(err)
                        this.errorApi(err);
                    },
                });
            });
        },
    },
}
</script>

